import { Navigate, Route, Routes } from "react-router-dom"
import React from "react"
import ImportManualReservationOtaCommitionFeeFromCsv from "../pages/ImportManualReservationOtaCommitionFeeFromCsv"

const Property = React.lazy(() => import("../pages/Property"))
const PropertyCalendarPage = React.lazy(
    () => import("../pages/PropertyCalendarPage")
)
const Unassigned = React.lazy(() => import("../pages/Unassigned"))
const LeaseNeedActionPage = React.lazy(
    () => import("../pages/LeaseNeedActionsPage")
)
const PropertyDetail = React.lazy(() => import("../pages/PropertyDetail"))
const ImportLeaseFromCsv = React.lazy(
    () => import("../pages/ImportLeaseFromCsv")
)
const ImportAdditionalSalesFromCsv = React.lazy(
    () => import("../pages/ImportAdditionalSalesFromCsv")
)
const ImportProprietaryFromCsv = React.lazy(
    () => import("../pages/ImportProprietaryFromCsv")
)
const ImportRoomTypeFromCSv = React.lazy(
    () => import("../pages/ImportRoomTypeFromCsv")
)
const ImportCreateListingFromCsv = React.lazy(
    () => import("../pages/ImportCreateListingFromCsv")
)
const ImportListingFromCsv = React.lazy(
    () => import("../pages/ImportListingFromCsv")
)
const ImportPropertyFromCsv = React.lazy(
    () => import("../pages/ImportPropertyFromCsv")
)
const ImportCreatePropertyFromCsv = React.lazy(
    () => import("../pages/ImportCreatePropertyFromCsv")
)

const ImportListingOTARelationFromCsv = React.lazy(
    () => import("../pages/ImportListingOTARelationFromCsv")
)
const ImportRoomTypeWeekdaySettingsFromCsv = React.lazy(
    () => import("../pages/ImportRoomTypeWeekdaySettingsFromCsv")
)
const RoomTypeDetail = React.lazy(() => import("../pages/RoomTypeDetail"))
const CommonAreaDetail = React.lazy(() => import("../pages/CommonAreaDetail"))
const RoomTypeCalendar = React.lazy(() => import("../pages/RoomTypeCalendar"))
const AirbnbCalendar = React.lazy(() => import("../pages/AirbnbCalendar"))
const RoomDetail = React.lazy(() => import("../pages/RoomDetail"))
const ReservationDetailPage = React.lazy(
    () => import("../pages/ReservationDetailPage")
)
const ProprietaryDetailPage = React.lazy(
    () => import("../pages/ProprietaryDetailPage")
)
const LeaseDetailPage = React.lazy(() => import("../pages/LeaseDetailPage"))
const PricingPage = React.lazy(() => import("../pages/PricingPage"))
const RoomTypeMonitor = React.lazy(() => import("../pages/RoomTypeMonitor"))
const AchievementPage = React.lazy(() => import("../pages/AchievementPage"))
const AchievementReservationDetailPage = React.lazy(
    () => import("../pages/AchievementReservationDetailPage")
)
const AchievementLeaseDetailPage = React.lazy(
    () => import("../pages/AchievementLeaseDetailPage")
)
const AirbnbChargePage = React.lazy(() => import("../pages/AirbnbChargePage"))
const AvailabilityCalendarPage = React.lazy(
    () => import("../pages/AvailabilityCalendarPage")
)
const InCheckListingsPage = React.lazy(
    () => import("../pages/InCheckListingsPage")
)
const CalendarOperationLogPage = React.lazy(
    () => import("../pages/CalendarOperationLogPage")
)
const MinpakuYearStocksPage = React.lazy(
    () => import("../pages/MinpakuYearStocksPage")
)
const InventoryRoutes = React.lazy(() => import("../pages/inventory/routes"))
const ProprietaryListPage = React.lazy(
    () => import("../pages/ProprietaryListPage")
)
const OwnerPage = React.lazy(() => import("../pages/OwnerPage"))

const OwnerFileUploadPage = React.lazy(
    () => import("../pages/OwnerFileUploadPage")
)
const OwnerFileListPage = React.lazy(() => import("../pages/OwnerFileListPage"))

const ReservationsPage = React.lazy(() => import("../pages/ReservationsPage"))
const ListingPresentationPage = React.lazy(
    () => import("../pages/ListingPresentationPage")
)
const EditListingPresentationSchemaPage = React.lazy(
    () => import("../pages/EditListingPresentationSchemaPage")
)
const DevOnlyOtaReservationPage = React.lazy(
    () => import("../pages/DevOnlyOtaReservationPage")
)
const AssignHistoryPage = React.lazy(
    () => import("../pages/RoomTypeDetail/AssignHistoryPage")
)
const PictureSorterPage = React.lazy(() => import("../pages/PictureSorterPage"))
const TroubleFormPage = React.lazy(() => import("../pages/TroubleFormPage"))
const Beds24AuthPage = React.lazy(() => import("../pages/Beds24AuthPage"))
const RoomCopyPage = React.lazy(() => import("../pages/RoomCopy/RoomCopyPage"))

const BigQueryIntegrationIndexPage = React.lazy(
    () => import("../pages/BigQueryIntegrationIndexPage")
)
const BigQueryIntegrationPage = React.lazy(
    () => import("../pages/BigQueryIntegrationPage")
)
const BigQueryIntegrationFormPage = React.lazy(
    () => import("../pages/BigQueryIntegrationFormPage")
)
const RevenueRecognitionPage = React.lazy(
    () => import("../pages/RevenueRecognitionPage")
)
const StaySalesV2Page = React.lazy(() => import("../pages/StaySalesV2Page"))
const PropertyMapPage = React.lazy(() => import("../pages/PropertyMapPage"))
const CreateInvoicePeek = React.lazy(
    () => import("../pages/Invoice/CreatInvoicePeek")
)
const EditInvoicePeek = React.lazy(
    () => import("../pages/Invoice/EditInvoicePeek")
)
const ReconciliationListPage = React.lazy(
    () => import("../pages/ReconciliationListPage")
)
const PendingTransactionListPage = React.lazy(
    () => import("../pages/PendingTransactionListPage")
)

const SearchInvoicePage = React.lazy(
    () => import("../pages/Invoice/SearchInvoicePage")
)
const MediaViewerPage = React.lazy(() => import("../pages/MediaViewerPage"))

export const MainAuthRoutes = () => {
    return (
        <Routes>
            <Route index path={"/property"} element={<Property />} />
            <Route path={"/unassigned"} element={<Unassigned />} />
            <Route
                path={"/leaseNeedAction"}
                element={<LeaseNeedActionPage />}
            />
            <Route
                path={"/property/:id/calendar"}
                element={<PropertyCalendarPage />}
            />
            <Route path={"/property/:id/*"} element={<PropertyDetail />} />

            <Route
                path={"/importProprietaryFromCsv/*"}
                element={<ImportProprietaryFromCsv />}
            />
            <Route
                path={"/importRoomTypeFromCsv"}
                element={<ImportRoomTypeFromCSv />}
            />
            <Route
                path={"/importAdditionalSalesFromCsv"}
                element={<ImportAdditionalSalesFromCsv />}
            />
            <Route
                path={"/importLeaseFromCsv"}
                element={<ImportLeaseFromCsv />}
            />
            <Route
                path={"/importCreateListingFromCsv"}
                element={<ImportCreateListingFromCsv />}
            />
            <Route
                path={"/importListingFromCsv"}
                element={<ImportListingFromCsv />}
            />
            <Route
                path={"/importManualReservationOtaCommitionFeeFromCsv"}
                element={<ImportManualReservationOtaCommitionFeeFromCsv />}
            />
            <Route
                path={"/importPropertyFromCsv"}
                element={<ImportPropertyFromCsv />}
            />
            <Route
                path={"/importCreatePropertyFromCsv"}
                element={<ImportCreatePropertyFromCsv />}
            />
            <Route
                path={"/importListingOTARelationFromCsv"}
                element={<ImportListingOTARelationFromCsv />}
            />
            <Route
                path={"/importRoomTypeWeekdaySettingsFromCsv"}
                element={<ImportRoomTypeWeekdaySettingsFromCsv />}
            />
            <Route path={"/roomType/:id"} element={<RoomTypeDetail />} />
            <Route
                path={"/roomType/:id/calendar"}
                element={<RoomTypeCalendar />}
            />
            <Route
                path={"/roomType/:id/calendarOperationLog"}
                element={<CalendarOperationLogPage />}
            />
            <Route
                path={"/roomType/:id/assignHistory"}
                element={<AssignHistoryPage />}
            />
            <Route
                path={"/roomType/:id/airbnbCalendar"}
                element={<AirbnbCalendar />}
            />
            <Route path={"/roomType/:id/copy"} element={<RoomCopyPage />} />
            <Route
                path={"/listing/:id/presentation"}
                element={<ListingPresentationPage />}
            />
            <Route path="/editListingPresentationSchema">
                <Route index element={<EditListingPresentationSchemaPage />} />
                <Route
                    path=":schemaId"
                    element={<EditListingPresentationSchemaPage />}
                />
            </Route>
            <Route path={"/listing/:id/*"} element={<RoomDetail />} />
            <Route
                path={"/reservation/:id"}
                element={<ReservationDetailPage />}
            >
                <Route path="invoice" element={<CreateInvoicePeek />} />
                <Route
                    path="invoice/:invoiceId"
                    element={<EditInvoicePeek />}
                />
            </Route>
            <Route path={"/invoice/search"} element={<SearchInvoicePage />} />
            <Route
                path={"/proprietary/:id"}
                element={<ProprietaryDetailPage />}
            />
            <Route path={"/lease/:id"} element={<LeaseDetailPage />} />
            <Route path={"/pricing"} element={<PricingPage />} />
            <Route path={"/roomTypeMonitor"} element={<RoomTypeMonitor />} />
            <Route path={"/achievement"} element={<AchievementPage />} />
            <Route
                path={"/achievement/reservationDetail"}
                element={<AchievementReservationDetailPage />}
            />
            <Route
                path={"/achievement/leaseDetail"}
                element={<AchievementLeaseDetailPage />}
            />
            <Route path={"/airbnbCharge"} element={<AirbnbChargePage />} />
            <Route
                path={"/availabilityCalendar"}
                element={<AvailabilityCalendarPage />}
            />
            <Route
                path={"/inCheckListings"}
                element={<InCheckListingsPage />}
            />
            <Route
                path={"/minpakuYearStocks"}
                element={<MinpakuYearStocksPage />}
            />
            <Route path={"/inventory/*"} element={<InventoryRoutes />} />
            <Route
                path={"/proprietaryList"}
                element={<ProprietaryListPage />}
            />
            <Route path={"/owner"} element={<OwnerPage />} />
            <Route
                path={"/owner/upload/:id"}
                element={<OwnerFileUploadPage />}
            />
            <Route
                path={"/owner/filelist/:id"}
                element={<OwnerFileListPage />}
            />
            <Route
                path={"/owner/filelist/:id"}
                element={<OwnerFileListPage />}
            />
            <Route path={"/reservation"} element={<ReservationsPage />} />
            <Route
                path={"/reconciliationList"}
                element={<ReconciliationListPage />}
            />
            <Route
                path={"/pendingTransactionList"}
                element={<PendingTransactionListPage />}
            />
            <Route
                path={"/devonly/ota"}
                element={<DevOnlyOtaReservationPage />}
            />
            <Route path={"/commonArea/:id"} element={<CommonAreaDetail />} />
            <Route path={"/pictureSorter"} element={<PictureSorterPage />} />
            <Route path={"/troubleForm"} element={<TroubleFormPage />} />
            <Route path={"/beds24Auth"} element={<Beds24AuthPage />} />
            <Route
                path={"/bigquery_integration"}
                element={<BigQueryIntegrationIndexPage />}
            />
            <Route
                path="bigquery_integration/:datasetId/:tableId"
                element={<BigQueryIntegrationPage />}
            />
            <Route
                path="bigquery_integration/:datasetId/:tableId/form"
                element={<BigQueryIntegrationFormPage />}
            />
            <Route
                path={"/revenue-recognition"}
                element={<RevenueRecognitionPage />}
            />
            <Route path={"/stay-sales-v2"} element={<StaySalesV2Page />} />
            <Route path={"/property-map"} element={<PropertyMapPage />} />
            <Route path={"/mediaViewer"} element={<MediaViewerPage />} />
            <Route path={"*"} element={<Navigate to={"/property"} />} />
        </Routes>
    )
}
